<template>
    <content-layout class="position-relative">
        <template slot="header">
            <div class="breadcrumb">
                <span class="crumb"><router-link :to="{ name: 'home' }">Sākums</router-link></span>
                <span class="crumb"><router-link :to="{ name: 'posts' }">Jaunumi</router-link></span>
                <span class="crumb">{{post.title}}</span>
            </div>
            <h1 class="category-title">{{post.title}}</h1>
        </template>

        <spinner v-if="loading" class="spinner position-absolute"></spinner>

        <div class="row page-container" v-if="!loading">
            <div class="column small-12 large-8">
                <div class="page">
                    <p class="date">{{post.created_at | moment("DD/MM/YYYY")}}</p>
                    <div v-html="post.content"></div>
                </div>
            </div>
        </div>

    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/CategoryLayout';
    import posts from '../api/posts';

    export default {
        components: {ContentLayout},

        props: {
            id: {
                type: [String, Number]
            }
        },

        data() {
            return {
                post: {
                    id: undefined,
                    title: null,
                    description: null,
                    content: null
                },

                loading: false
            }
        },

        methods: {
            loadPost(id) {
                this.loading = true;
                posts.find(id).then(res => {
                    this.post = res.data;
                    this.loading = false;
                });
            }
        },

        created() {
            this.loadPost(this.id);
        }
    }
</script>

<style scoped lang="scss">
    .page {
        min-height: 300px;
    }

    .date {
        font-size: 11px;
        color: #999999;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Post.vue